import { createContext, useContext } from "react";

export const PropertyContext = createContext<string[] | null>(null);

export function useTemplateProperties() {
  const result = useContext(PropertyContext);

  if (result === null) {
    throw new Error(
      "useTemplateProperties must be used inside ProvidePropertiesByTemplateId",
    );
  }

  return result;
}
